export default function formatNumber(value: number | string) {
  const num = typeof value === "string" ? Number(value) : value;
  if (num === null || isNaN(num)) {
    return "";
  }
  return num.toLocaleString("ko-KR");
}
